import { ConnectedAccount } from '@/settings/schemas/external-storage-schema'

export function getAccountStatusMeta(status: ConnectedAccount['status']): { label: string; dotClassName: string; helpText: string } {
  switch (status) {
    case 'connected':
      return {
        label: 'Connected',
        dotClassName: 'bg-green-600',
        helpText: 'Go to a matter to select folders.',
      }
    case 'reauth_required':
      return {
        label: 'Reconnect',
        dotClassName: 'bg-amber-500',
        helpText: 'Reconnect this account to continue selecting folders.',
      }
    case 'error':
      return {
        label: 'Connection issue',
        dotClassName: 'bg-red-600',
        helpText: 'Reconnect this account or disconnect it to start again.',
      }
    case 'disconnected':
      return {
        label: 'Disconnected',
        dotClassName: 'bg-brand-neutral-400',
        helpText: 'This account is disconnected.',
      }
  }
}
